import { motion } from "framer-motion";
import React from "react";
import { isMobile } from "react-device-detect";
import BarracksButtons from "./BarracksButtons";
import BarracksInfo from "./BarracksInfo";
import BarracksTabs from "./BarracksTabs";

const BarracksHeader = () => {
  return (
    <motion.div
      exit={{ opacity: 0, y: 200 }}
      transition={{ duration: 0.4 }}
      initial={isMobile ? undefined : { opacity: 0, y: 200 }}
      animate={{ opacity: 1, y: 0 }}
      className="my-3 ps-2 flex-wrap d-flex align-items-center justify-content-between"
    >
      <BarracksInfo />
      <BarracksTabs />
      <BarracksButtons />
    </motion.div>
  );
};

export default BarracksHeader;
